(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidekit-kit-farofa"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sidekit-builder')) {
    class SidekitBuilder extends HTMLElement {
      connectedCallback() {
        this.flavors = [...this.querySelectorAll('[data-sidekit-flavor]')];
        this.tiers = [...this.querySelectorAll('[data-sidekit-tier]')]
          .map((element) => ({
            element,
            size: Number(element.dataset.size),
            discountPercent: Number(element.dataset.discountPercent) || 0,
          }))
          .sort((a, b) => a.size - b.size);
        this.quantities = new Map(this.flavors.map((flavor) => [flavor.dataset.blockId, 0]));
        this.minQuantity = Number(this.dataset.minQuantity);
        this.maxQuantity = Number(this.dataset.maxQuantity);
        this.compareUnitPrice = Number(this.dataset.compareUnitPrice);
        this.moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency: Shopify.currency.active,
        });
        this.abortController = new AbortController();
        this.#randomizeSocialProof();
        this.#bindEvents();
        this.#render();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      #randomizeSocialProof() {
        if (this.dataset.randomizeSocialProof !== 'true') return;
        const socialProof = this.querySelector('[data-sidekit-social-proof]');
        if (!socialProof) return;

        const minimum = Number(this.dataset.socialProofMin);
        const maximum = Number(this.dataset.socialProofMax);
        const lower = Math.min(minimum, maximum);
        const upper = Math.max(minimum, maximum);
        const value = Math.floor(Math.random() * (upper - lower + 1)) + lower;
        const formattedValue = `+${value.toLocaleString(document.documentElement.lang || 'pt-BR')}`;
        socialProof.textContent = socialProof.textContent.replace(/\+?[\d.,]+/, formattedValue);
        socialProof.removeAttribute('data-sidekit-random-pending');
      }

      #bindEvents() {
        const signal = this.abortController.signal;

        for (const thumb of this.querySelectorAll('[data-sidekit-thumb]')) {
          thumb.addEventListener('click', () => this.#selectImage(thumb), { signal });
        }

        for (const flavor of this.flavors) {
          flavor.querySelector('[data-sidekit-decrease]')?.addEventListener(
            'click',
            () => this.#changeQuantity(flavor, -1),
            { signal }
          );
          flavor.querySelector('[data-sidekit-increase]')?.addEventListener(
            'click',
            () => this.#changeQuantity(flavor, 1),
            { signal }
          );
        }

        this.querySelector('[data-sidekit-submit]')?.addEventListener(
          'click',
          () => this.#addToCart(),
          { signal }
        );
      }

      #selectImage(thumb) {
        const hero = this.querySelector('[data-sidekit-hero]');
        if (!hero || !thumb.dataset.image) return;
        hero.src = thumb.dataset.image;
        hero.srcset = '';
        hero.alt = thumb.dataset.alt;
        for (const item of this.querySelectorAll('[data-sidekit-thumb]')) {
          const active = item === thumb;
          item.classList.toggle('sidekit__thumb--active', active);
          item.setAttribute('aria-pressed', String(active));
        }
      }

      #flavorMax(flavor) {
        if (flavor.dataset.available !== 'true') return 0;
        if (flavor.dataset.inventoryPolicy === 'continue') return Number.POSITIVE_INFINITY;
        if (!flavor.dataset.inventoryManagement) return Number.POSITIVE_INFINITY;
        const stock = Number(flavor.dataset.inventory);
        return Number.isFinite(stock) ? Math.max(0, stock) : 0;
      }

      #changeQuantity(flavor, change) {
        const id = flavor.dataset.blockId;
        const current = this.quantities.get(id) || 0;
        if (change > 0 && current >= this.#flavorMax(flavor)) return;
        if (change < 0 && current <= 0) return;
        this.quantities.set(id, current + change);
        this.#render();
      }

      #totalQuantity() {
        let total = 0;
        for (const quantity of this.quantities.values()) total += quantity;
        return total;
      }

      #currentTier(total) {
        let current = null;
        for (const tier of this.tiers) {
          if (total >= tier.size) current = tier;
        }
        return current;
      }

      #actualProductsTotal() {
        let total = 0;
        for (const flavor of this.flavors) {
          total += Number(flavor.dataset.productPrice) * (this.quantities.get(flavor.dataset.blockId) || 0);
        }
        return total;
      }

      #compareProductsTotal() {
        let total = 0;
        for (const flavor of this.flavors) {
          const quantity = this.quantities.get(flavor.dataset.blockId) || 0;
          const compare = Number(flavor.dataset.comparePrice) || Number(flavor.dataset.productPrice) || 0;
          total += compare * quantity;
        }
        return total;
      }

      #render() {
        const total = this.#totalQuantity();
        const tier = this.#currentTier(total);
        const productsTotal = this.#actualProductsTotal();
        const discountPercent = Number(tier?.discountPercent) || 0;
        const calculatedTotal = Math.round(productsTotal * (100 - discountPercent) / 100);
        const compareFromProducts = this.#compareProductsTotal();
        const compareFallback = this.compareUnitPrice > 0 ? this.compareUnitPrice * total : 0;
        const compareTotal = Math.max(compareFromProducts, compareFallback, productsTotal);
        const complete = total > 0;

        this.querySelector('[data-sidekit-count]').textContent = String(total);

        let reachedCount = 0;
        for (const item of this.tiers) {
          const reached = total >= item.size;
          item.element.classList.toggle('sidekit__tier--reached', reached);
          if (reached) reachedCount += 1;
        }

        const fill = this.querySelector('[data-sidekit-tier-fill]');
        if (fill) {
          const pct = reachedCount === 0 ? 0 : ((reachedCount - 0.5) / Math.max(1, this.tiers.length)) * 100;
          fill.style.width = `${pct}%`;
        }

        const status = this.querySelector('[data-sidekit-progress-status]');
        if (status) {
          const currentOff = Number(tier?.discountPercent) || 0;
          const next = this.tiers.find((item) => total < item.size);
          if (!tier && next) {
            status.textContent = `+${next.size - total} → ${next.discountPercent}%`;
          } else if (!next) {
            status.textContent = currentOff > 0 ? `${currentOff}% OFF` : '';
          } else {
            status.textContent = `${currentOff}% · +${next.size - total} → ${next.discountPercent}%`;
          }
        }

        for (const flavor of this.flavors) {
          const quantity = this.quantities.get(flavor.dataset.blockId) || 0;
          const available = flavor.dataset.available === 'true';
          flavor.classList.toggle('sidekit__flavor--selected', quantity > 0);
          flavor.querySelector('[data-sidekit-quantity]').textContent = String(quantity);
          flavor.querySelector('[data-sidekit-decrease]').disabled = quantity === 0;
          flavor.querySelector('[data-sidekit-increase]').disabled =
            !available || quantity >= this.#flavorMax(flavor);
        }

        this.querySelector('[data-sidekit-total]').textContent = this.#formatMoney(calculatedTotal);
        const compare = this.querySelector('[data-sidekit-compare]');
        const saving = this.querySelector('[data-sidekit-saving]');
        const unit = this.querySelector('[data-sidekit-unit]');
        const badge = this.querySelector('[data-sidekit-badge]');
        const hasSaving = total > 0 && compareTotal > calculatedTotal;
        compare.hidden = !hasSaving;
        compare.textContent = hasSaving ? this.#formatMoney(compareTotal) : '';
        saving.textContent = hasSaving
          ? `${this.dataset.labelSelected} ${this.#formatMoney(compareTotal - calculatedTotal)}`
          : '';
        if (unit) {
          unit.textContent = total > 0
            ? `${this.#formatMoney(Math.round(calculatedTotal / total))} ${this.dataset.labelPerUnit || '/ un'}`
            : '';
        }
        if (badge) {
          badge.hidden = !(discountPercent > 0 && total > 0);
          badge.textContent = discountPercent > 0 ? `${discountPercent}% OFF` : '';
        }

        const submit = this.querySelector('[data-sidekit-submit]');
        submit.disabled = !complete;
        this.querySelector('[data-sidekit-submit-label]').textContent =
          complete ? this.dataset.labelAdd : this.dataset.labelIncomplete;
      }

      #formatMoney(cents) {
        return this.moneyFormatter.format(cents / 100);
      }

      async #addToCart() {
        const submit = this.querySelector('[data-sidekit-submit]');
        const label = this.querySelector('[data-sidekit-submit-label]');
        const status = this.querySelector('[data-sidekit-status]');
        const items = this.flavors
          .map((flavor) => ({
            id: Number(flavor.dataset.variantId),
            quantity: this.quantities.get(flavor.dataset.blockId) || 0,
            properties: {
              _sidekit: '1',
              _sidekit_title: this.dataset.kitTitle || '',
              _sidekit_flavor: flavor.dataset.flavorTitle || '',
              _sidekit_url: this.dataset.kitUrl || '',
              _sidekit_handle: this.dataset.kitHandle || '',
            },
          }))
          .filter((item) => item.id && item.quantity > 0);

        if (!items.length) return;
        submit.disabled = true;
        label.textContent = this.dataset.labelAdding;
        status.textContent = '';

        try {
          const cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const payload = { items };
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            payload.sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
            payload.sections_url = window.location.pathname;
            if (typeof cartDrawer.setActiveElement === 'function') {
              cartDrawer.setActiveElement(document.activeElement);
            }
          }

          const response = await fetch(`${this.dataset.cartAddUrl}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || `Cart request failed: ${response.status}`);

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(data);
          } else if (this.dataset.redirectToCart === 'true') {
            window.location.assign(this.dataset.cartUrl);
            return;
          }

          status.textContent = '';
        } catch (error) {
          console.error('SIDEKIT cart error', error);
          status.textContent = this.dataset.labelError;
        } finally {
          label.textContent = this.dataset.labelAdd;
          submit.disabled = false;
        }
      }
    }

    customElements.define('sidekit-builder', SidekitBuilder);
  }

  } catch(e) { console.error(e); }
})();
})();
